module.exports = __webpack_public_path__ + "img/card-configuration-services-and-cost.436c979a.svg";